import { ITextValue } from '@/types/common';

export enum CreatedUpdatedByOptionEnum {
  anyone = 'anyone',
  me = 'me',
  myteam = 'myteam',
  users = 'users',
}

export const CreatedUpdateByOptionEnumLabels = {
  [CreatedUpdatedByOptionEnum.anyone]: 'All Users',
  [CreatedUpdatedByOptionEnum.me]: 'Me',
  [CreatedUpdatedByOptionEnum.myteam]: 'Me or my team',
  [CreatedUpdatedByOptionEnum.users]: 'Select user(s)',
};

export const createdUpdatedByTextValues = (): ITextValue<CreatedUpdatedByOptionEnum>[] => {
  return Object.keys(CreatedUpdateByOptionEnumLabels).map((key) => ({
    value: key as CreatedUpdatedByOptionEnum,
    text: CreatedUpdateByOptionEnumLabels[key],
  }));
}
